import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21fcdc1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item van-hairline--bottom" }

import { computed, ComputedRef } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'form-item-wrap',
  props: {
  label: {
    type: String,
    default: '',
  },
  require: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;


const getLabelClass: ComputedRef<string> = computed(() => {
  return props.require ? 'red-star' : ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["label", _unref(getLabelClass)])
    }, _toDisplayString(__props.label), 3),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})